<template>
  <div id="app">
    <Slide width="250" :closeOnNavigation="true" right noOverlay>
      <span><router-link to="/">Home</router-link></span>
      <router-link to="/dopa">DOPAmine</router-link>
      <router-link to="/dobu">doBUTAmine</router-link>
       <router-link to="/nica">NiCARdipine</router-link>
      <router-link to="/nore">Norepinephrine</router-link>
      <router-link to="/crcl">CrCl calc.</router-link>
    </Slide>
    <main id="page-wrap">

      <router-link to="/"><img src="./assets/logo.png" height="24px"></router-link>
      <router-view></router-view>
      <Kmpfooter></Kmpfooter>
    </main>
  </div>
</template>

<script>
import Kmpfooter from "./components/Kmpfooter.vue";
import { Slide } from "vue-burger-menu";

export default {
  name: "app",
  components: {
    Kmpfooter,
    Slide
  }
};
</script>

<style >
div {
  font-family: "Gill Sans", "Gill Sans MT", Calibri, "Trebuchet MS", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: left;
  color: #2c3e50;
  width: 400px;
  margin: auto;
}
ul {
  margin: 0;
  margin-top: 15px;
  padding: 0;
}
li {
  margin-right: 8px;
  margin-left: 4px;
}
a:link,
a:visited,
a:hover,
a:active {
  text-decoration: none;
  color: #5b718a;
}
.title {
  font-size: 20px;
  margin-top: 20px;
  color: #364f6b;
  border-bottom: solid 1px;
}
div#warning {
  font-size: 15px;
  color: #a81064;
}
.desc {
  font-size: 12px;
  color: #be5683;
}
div#sop {
  margin-top: 10px;
  font-size: 16px;
  color: black;
  
}
</style>

